import { Controller } from "@hotwired/stimulus"

// Add/remove travel-companion rows in the RSVP form (nested guest fields).
export default class extends Controller {
  static targets = ["container", "template", "row"]
  static values = { start: { type: Number, default: 2 } }

  connect() {
    this.renumber()
  }

  add() {
    const html = this.templateTarget.innerHTML.replaceAll("NEW_RECORD", Date.now().toString())
    this.containerTarget.insertAdjacentHTML("beforeend", html)
    this.changed()
  }

  remove(event) {
    const row = event.target.closest('[data-guest-list-target="row"]')
    if (row.dataset.newRecord === "true") {
      row.remove()
    } else {
      row.querySelector('input[name*="_destroy"]').value = "1"
      row.hidden = true
    }
    this.changed()
  }

  changed() {
    this.renumber()
    this.dispatch("changed")
  }

  renumber() {
    let number = this.startValue // slots before this are the ticket holders
    this.rowTargets.forEach((row) => {
      if (row.hidden) return
      const num = row.querySelector('[data-guest-list-target="num"]')
      if (num) num.textContent = number++
    })
  }
}
